<template>
  <v-snackbar
    v-model="localShow"
    :timeout="timeout"
    :color="snackbarColor"
    :class="typeClass"
    position="absolute"
    location="top end"
    :z-index="100000000"
  >
    <div class="snackbar-content" :class="typeClass">
      <v-icon :icon="iconType" size="24" class="mr-2" />
      <div>
        <div v-if="title" class="snackbar-title">{{ title }}</div>
        <div class="snackbar-message">{{ text }}</div>
      </div>
      <v-btn
        icon
        variant="text"
        size="small"
        @click="localShow = false"
        class="close-btn"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </div>
  </v-snackbar>
</template>

<script setup>
import { computed, defineEmits, defineProps } from "vue";

const props = defineProps({
  show: {
    type: Boolean,
    default: false,
  },
  type: {
    type: String,
    default: "success",
    validator: (value) =>
      ["success", "error", "warning", "info", "plain"].includes(value),
  },
  title: {
    type: String,
    default: "",
  },
  text: {
    type: String,
    required: true,
  },
  timeout: {
    type: Number,
    default: 5000,
  },
});

const emit = defineEmits(["update:show"]);

const localShow = computed({
  get: () => props.show,
  set: (value) => emit("update:show", value),
});

const snackbarColor = computed(() => {
  switch (props.type) {
    case "success":
      return "#ffffff";
    case "error":
      return "#F44336";
    case "warning":
      return "#FF9800";
    case "info":
      return "#2196F3";
    case "plain":
      return "#ffffff";
    default:
      return "#4CAF50";
  }
});

const iconType = computed(() => {
  switch (props.type) {
    case "success":
      return "mdi-check-circle-outline";
    case "error":
      return "mdi-alert-circle";
    case "warning":
      return "mdi-alert";
    case "info":
      return "mdi-information";
    case "plain":
      return "mdi-check-circle-outline";
    default:
      return "mdi-check-circle";
  }
});

const typeClass = computed(() => `snackbar-${props.type}`);
</script>

<style scoped>
.snackbar-content {
  display: flex;
  align-items: center;
  position: relative;
  min-width: 280px;
  max-width: 400px;
  border-radius: 4px;
  padding-right: 36px;
}

.snackbar-title {
  font-weight: 600;
  font-size: var(--fs-medium);
  margin-bottom: 4px;
}

.snackbar-message {
  font-size: var(--fs-small);
  line-height: 1.4;
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.snackbar-content > div {
  flex: 1;
  min-width: 0;
}

.close-btn {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  margin-left: auto;
  color: white;
  opacity: 0.8;
}

.close-btn:hover {
  opacity: 1;
}

.snackbar-plain,
.snackbar-success {
  color: #00925e;
}

.snackbar-plain .close-btn,
.snackbar-success .close-btn {
  color: #00925e;
  opacity: 0.8;
}

.snackbar-plain .close-btn:hover,
.snackbar-success .close-btn:hover {
  opacity: 1;
}
</style>
